import { state, State } from '../models'

export function getState(): State {
    return state
}
